import './sw-generic-cms-page-assignment.scss';

const { Component } = Shopware;

Component.extend('acris-generic-cms-page-assignment', 'sw-generic-cms-page-assignment', {

    emits: ['update:cms-page'],

    methods: {
        onLayoutSelect(selectedLayoutId, selectedLayout) {
            this.$super('onLayoutSelect', selectedLayoutId);

            this.$emit('update:cms-page', selectedLayout);
        },
    },
});
